/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Remove_Set_ButtonInputs */

const en_tags_manager_remove_set_button = /** @type {(inputs: Tags_Manager_Remove_Set_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const fr_tags_manager_remove_set_button = /** @type {(inputs: Tags_Manager_Remove_Set_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

const de_tags_manager_remove_set_button = /** @type {(inputs: Tags_Manager_Remove_Set_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen`)
};

const it_tags_manager_remove_set_button = /** @type {(inputs: Tags_Manager_Remove_Set_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovere`)
};

const ru_tags_manager_remove_set_button = /** @type {(inputs: Tags_Manager_Remove_Set_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалять`)
};

const es_tags_manager_remove_set_button = /** @type {(inputs: Tags_Manager_Remove_Set_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const zh_cn2_tags_manager_remove_set_button = /** @type {(inputs: Tags_Manager_Remove_Set_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消除`)
};

const ja_tags_manager_remove_set_button = /** @type {(inputs: Tags_Manager_Remove_Set_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取り除く`)
};

const hi_tags_manager_remove_set_button = /** @type {(inputs: Tags_Manager_Remove_Set_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निकालना`)
};

const pt_pt2_tags_manager_remove_set_button = /** @type {(inputs: Tags_Manager_Remove_Set_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover`)
};

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Tags_Manager_Remove_Set_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_remove_set_button = /** @type {((inputs?: Tags_Manager_Remove_Set_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Remove_Set_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_remove_set_button(inputs)
	if (locale === "de") return de_tags_manager_remove_set_button(inputs)
	if (locale === "it") return it_tags_manager_remove_set_button(inputs)
	if (locale === "ru") return ru_tags_manager_remove_set_button(inputs)
	if (locale === "es") return es_tags_manager_remove_set_button(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_remove_set_button(inputs)
	if (locale === "ja") return ja_tags_manager_remove_set_button(inputs)
	if (locale === "hi") return hi_tags_manager_remove_set_button(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_remove_set_button(inputs)
	return en_tags_manager_remove_set_button(inputs)
});